import { render, staticRenderFns } from "./largeAeration.vue?vue&type=template&id=0c07b802&scoped=true"
import script from "./largeAeration.vue?vue&type=script&lang=js"
export * from "./largeAeration.vue?vue&type=script&lang=js"
import style0 from "./largeAeration.vue?vue&type=style&index=0&id=0c07b802&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07b802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c07b802')) {
      api.createRecord('0c07b802', component.options)
    } else {
      api.reload('0c07b802', component.options)
    }
    module.hot.accept("./largeAeration.vue?vue&type=template&id=0c07b802&scoped=true", function () {
      api.rerender('0c07b802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeAeration.vue"
export default component.exports